module.exports = __webpack_public_path__ + "static/media/grey_warning.39482670.svg";